export default __webpack_public_path__ + "static/media/YAS0050.34I-27672_-17740_0.78f9b798.jpg";